<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'

export default {
  mixins: [fandomBasicMixin],
  mounted() { },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl
  },
  computed: {
    componentStyle() {
      const style = {};
      if (this.content.background_color) {
        if (this.content.background_color.indexOf('#') == 0 || this.content.background_color.indexOf('rgb') == 0) {
          style['background-color'] = this.content.background_color;
        } else {
          style['background-color'] = `var(--${this.content.background_color})`;
        }
      } else {
        style['background-color'] = 'var(--red-cabbage)';
      }
      return style;
    }
  }
}
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :style="componentStyle" :class="contentType" class="container-fluid recipe_quote text-white" stripe-chef-advice>
      <div class="row mx-0 py-4 justify-content-center">
        <div class="col-12 col-md-8 d-flex flex-column justify-content-center align-items-center py-2">
          <div 
            v-if="content.avatar" 
            class="quote__avatar rounded-circle mt-1 mb-3 bg-cover-center"
            :style="{'background-image': getBackgroundUrl(content.avatar.url)}"
          ></div>
          <div class="text-uppercase pb-3 font-xs">{{content.chef_name}}</div>
          <div class="text-uppercase text-center pb-4 h3">{{ft("recipe.chef_advice")}}</div>
          <div class="h4 d-block text-center quote__description mb-4" v-if="content.description" v-html="content.description"></div>
        </div>
      </div>    
    </div>
</template>

<style lang="scss" scoped>

[stripe-chef-advice] {

  .h4 {
    font-size: 1.625rem !important;
  }

  .quote__description {
    font-family: "Bressay";
  }

  .quote__avatar {
    width: 6rem;
    height: 6rem;
  }
  
}
</style>